<template>
    <div>
        <my-dialog ref="dialog" title="联系我们">
            <el-card shadow="hover" align="left">
                <div>请使用如下方式联系我们</div>
                <ul>
                    <!-- 特别注意，下面的 input size 不要调整，因为 H5 页面的字体大小和 iphone 的不一致，现在是按照 iphone 的情况设置的
                         况且现在 H5 本就不显示，因此按照 iphone 上的最佳尺寸进行调整 -->
                    <li style="line-height: 32px; font-size:14px !important;"
                        >官网邮箱:<input id="email" class="contactus_input" readonly size="23" :value="officalEmail"></input
                        ><span class="el-icon-copy-document" @click="copy('email')"></span
                        ><el-tooltip class="item" effect="dark" :manual="true" :value="showTooltip2" content="点击发送" placement="bottom"
                        ><span class="iconfont icon-sy-send-message" style="margin-left: 12px; font-size: 13px" @click="sendEmail"></span></el-tooltip>
                    </li>
                    <li style="line-height: 32px; font-size:14px !important;" v-if="isDisplayOfficalSite"
                        >官网地址:<input id="site" class="contactus_input" readonly size="15" :value="officalSite"></input
                        ><el-tooltip class="item" effect="dark" :manual="true" :value="showTooltip1" content="点击拷贝" placement="bottom"
                        ><span class="el-icon-copy-document" @click="copy('site')"></span></el-tooltip>
                    </li>
                </ul>
                <div align="center">Copyright &copy; 2021 {{companyName}}</div>
            </el-card>
        </my-dialog>
        <stick-pop v-bind="$attrs" @click="show">
            <i class="el-icon-message" style="font-weight: 600"></i>
        </stick-pop>
    </div>
</template>

<script>
    import StickPop from "./StickPop";
    import {getMyHeader, isHybridAgent, successMessage, Constants, HTML} from "../../../utils";
    import MyDialog from "../../commons/MyDialog";

    export default {
        name: "ContactUs",
        components: {StickPop, MyDialog},
        computed: {
            /**
             * official site 是敏感元素，因为它的尺度最大，担心在 ios 审核的时候不通过，因此通过后端的 frontend res ctrl 配置控制其展示
             */
            isDisplayOfficalSite(){
                return this.$store.state.displayCtrl === null ? false : this.$store.state.displayCtrl.website;
            },
            officalSite(){
                return Constants.officalSite;
            },
            officalEmail(){
                return Constants.officalEmail;
            },
            companyName() {
                return this.$store.state.displayCtrl === null ? "酷凡网络" : this.$store.state.displayCtrl.companyName
            }
        },
        data (){
            return {
                showTooltip1: false,
                showTooltip2: false,
                showTooltipDelay: 1000,
                hideTooltipAfter: 1200,
            }
        },
        methods: {
            show(){
                console.log('show contact us');
                setTimeout(()=>{
                    this.$refs.dialog.show();
                    setTimeout(()=>{
                        this.showTooltip1 = true; // 显示 tooltip1
                        setTimeout(()=>{
                            this.showTooltip1 = false; // 关闭 tooltip1
                            setTimeout(()=>{
                                this.showTooltip2 = true; // 显示 tooltip2
                                setTimeout(()=>{
                                    this.showTooltip2 = false; // 关闭 tooltip1
                                }, this.hideTooltipAfter)
                            }, this.showTooltipDelay)
                        }, this.hideTooltipAfter)
                    }, this.showTooltipDelay);
                }, 300);
            },

            reset(){
                this.showTooltip1 = false;
            },

            /**
             * @param id, the input element id.
             */
            copy(id){
                HTML.copy(id);
                successMessage('复制成功');
            },

            /**
             * 扎心了，在真机上发送，提示发送成功，结果压根发送不出去。
             * @deprecated 想了想，还是直接显示一个面板，显示一个邮箱地址和网站地址即可。
             */
            sendEmail(){
                var msg = plus.messaging.createMessage(plus.messaging.TYPE_EMAIL);
                msg.to = [this.officalEmail];
                // msg.subject = '测试邮件';
                // msg.body = '';
                plus.messaging.sendMessage(msg, function(){
                    alert( "已发送" );
                }, function(error){
                    console.log(JSON.stringify(error));
                });
            },

            // 发送短信，行为是在真机环境下，弹出手机短信发送窗口，并自动帮助你填充好手机号码和短信内容，需要用户自己点击发送。
            // https://www.html5plus.org/doc/zh_cn/messaging.html
            sendSms(){
                var msg = plus.messaging.createMessage(plus.messaging.TYPE_SMS);
                msg.to = ['18611497504', '15811140520'];
                msg.body = 'This is HTML5 Plus example test message';
                plus.messaging.sendMessage( msg );
            }
        }


    }
</script>

<style scoped>

    /deep/ .dialog-content-panel {
        height: 180px;
    }

    /* normal phone screen */
    @media (max-width: 350px) {

        /deep/ .dialog-content-panel {
            height: 220px;
        }
    }

    .contactus_input{
        border:0;
        padding: 0;
        font-size:14px
    }

</style>



// WEBPACK FOOTER //
// src/components/commons/stickpops/ContactUs.vue